<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full mx-1 sm:w-1/2">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Special Order {{ categoryName }} <span v-if="specialOrder.unit && specialOrder.unit_name"> - Unit {{ specialOrder.unit_name }}</span>
			</div>
			<div class="p-4">
				<div class="mb-2">
					<div class="my-1">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Search</label>
						<auto-complete v-model="selected" @input="selectProduct" :options="options" :search="searchText" @search="newSearchText => searchText = newSearchText"/>
						<p class="text-red-500 text-xs italic mt-1" v-if="errors.name">Required</p>
					</div>
				</div>
				<div class="py-4 bg-gray-100 rounded" :class="{'border border-red-500' : errors.qty || errors.feeds}" v-if="products.length">
					<template v-for="(product, i) in products">
						<div class="mb-2 flex items-center px-2" :key="i">
							<div class="flex-1 mr-2">
								<p class="">{{ product.name }}</p>
							</div>
							<div class="mr-2">
								<input class="w-32 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.qty" placeholder="qty">
							</div>
							<div class="w-52 mr-2" v-if="catType == 'reticulation'">
								<input class="w-32 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.feeds" placeholder="Feeds">
								<p class="text-red-500 text-xs italic mt-1" v-if="errors.feeds">Required</p>
							</div>
						</div>
					</template>					
					<p class="text-red-500 text-xs italic mt-1 px-2" v-if="errors.qty">Please check quantities</p>
				</div>
				<div class="mb-2" v-if="products.length">
					<div class="my-1">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Reason for special order</label>
						<textarea class="w-full appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.comment}"  v-model="details.comment" placeholder="" rows="4"></textarea>
						<p class="text-red-500 text-xs italic mt-1" v-if="errors.comment">Required</p>
					</div>
				</div>
				<div class="">
					<div class="my-1">
						<label class="inline-block mr-4 text-gray-700 text-sm mb-1">Category:</label>
						<span class="text-sm">{{ categoryName }}</span>
					</div>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="save">Send</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AutoComplete from './AutoComplete.vue'

export default {
	props: ['job', 'show', 'accountId', 'specialOrder'],
	data () {
		return {
			errors: {
				product_id: false,
				qty: false,
				comment: false,
			},
			details: {
				phase_id: this.specialOrder.phase,
				area_id: this.specialOrder.area,
				block_id: this.specialOrder.block,
				unit_id: this.specialOrder.unit,
				unit_name: this.specialOrder.unit_name,
				job_id: this.job.id,
				category: this.specialOrder.catId,
				comment: '',
				type: '',
				placed_by: ''
			},
			fetchedProducts: [],
			products: [],
			selected: null,
      		searchText: '',
		}
	},
	methods: {
		checkForErrors () {
			if(this.details.comment == String(this.details.comment).trim() === ''){
				this.errors.comment = true;
			}else{
				this.errors.comment = false;
			}
			let productErrors = this.products.filter(product => {
				return product.qty == '' ||  product.qty == null;
			});
			if(productErrors.length){
				this.errors.qty = true;
			}else{
				this.errors.qty = false;
			}
			return Object.values(this.errors).filter(error => {
				return error === true;
			}).length;
		},
		selectProduct (product) {
			//this.product.product_id = product.id;
			this.products.push({
				name: product.name,
				product_id: product.id,
				qty: null,
				feeds: 1,
			});
			this.selected = null;
			this.searchText = '';
		},
		cancel () {
			this.$emit('close')
		},
		save () {
			if (this.checkForErrors()) return;
			// console.log(this.product);
			// return;
			// console.log('here');
			this.$http.post(`jobs/${this.job.id}/specialorders/`, {
					'details': this.details,
					'products': this.products,
				})
				.then(response => {
					let success = {
						title: 'Action Successful',
						message: 'Order Placed Successfully!',
						type: 'success'
					}
					this.$store.commit('setStatus', success)	
					this.$emit('reload')
					this.$emit('close')
				})
				.catch(err => {
					this.error = err
				})
		}
	},
	computed: {
		categoryName: function () {
			return this.$store.getters.getProductCategoryNameById(this.specialOrder.catId)
		},
		options() {
			return this.fetchedProducts.filter(product =>
				product.name.toLowerCase().startsWith(this.searchText.toLowerCase())
			)
			.map(product =>
				({
					id: product.id,
					name: product.name
				})
			);
		},
		catType: function(){
			return this.$store.getters.getProductCategoryKeyByIndex(this.specialOrder.catId)
		}
	},
	components: {
		AutoComplete
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		this.details.type = this.$store.getters.getProductCategoryKeyByIndex(this.specialOrder.catId);
		this.details.placed_by = this.$store.getters['auth/userid'];

		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});

		this.$http.post('productsbycategory',{
			'category_id': this.specialOrder.catId
		}).then((response) => {
			this.fetchedProducts = response.data.products;
		})
	}
}
</script>
